var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuDisconnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#menu-disconnect_svg__clip0)",
    stroke: "#191C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.429 5.429c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0m2.59-4.481a9.996 9.996 0 00-2.59-9.661 9.996 9.996 0 00-9.66-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.379 14.621a3 3 0 010-4.242l4.242 4.242a3 3 0 01-4.242 0zM1.5 1.5l22 22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-disconnect_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik01LjQyODkzIDUuNDI4OTlDMS41MjM2OSA5LjMzNDI0IDEuNTIzNjkgMTUuNjY1OSA1LjQyODkzIDE5LjU3MTFDOS4zMzQxOCAyMy40NzY0IDE1LjY2NTggMjMuNDc2NCAxOS41NzExIDE5LjU3MTFNMjIuMTYwNiAxNS4wODk2QzIzLjA1MTUgMTEuNzUzNCAyMi4xODg0IDguMDQ2MjkgMTkuNTcxMSA1LjQyODk5QzE2Ljk1MzggMi44MTE3IDEzLjI0NjYgMS45NDg1MiA5LjkxMDQ1IDIuODM5NDQiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuMzc4NyAxNC42MjE0QzkuMjA3MTEgMTMuNDQ5OCA5LjIwNzExIDExLjU1MDMgMTAuMzc4NyAxMC4zNzg3TDE0LjYyMTMgMTQuNjIxNEMxMy40NDk3IDE1Ljc5MjkgMTEuNTUwMyAxNS43OTI5IDEwLjM3ODcgMTQuNjIxNFoiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41IDEuNUwyMy41IDIzLjUiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IDAuNSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgMenuDisconnect as ReactComponent };